import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAddSellerRequest } from '../models/models'

export class AddDealerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authSeller/AddAuthSeller',
      requesterInfo,
    })
  }

  public async AddDealer(req: IAddSellerRequest): Promise<boolean> {
    return await this.postAsync<boolean>(req)
  }
}
